import { render } from "./FrisbuySrStories.vue?vue&type=template&id=17b439ae&scoped=true"
import script from "./FrisbuySrStories.vue?vue&type=script&lang=js"
export * from "./FrisbuySrStories.vue?vue&type=script&lang=js"

import "./FrisbuySrStories.vue?vue&type=style&index=0&id=17b439ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b439ae"]])

export default __exports__